<template>
  <b-form-group>
    <!-- <template slot="label">
      <span
        v-back-to-default="[
          $parent.inheritedControlInfo,
          control,
          'customCode',
          $parent.backToDefault
        ]"
      >
        Workflow:
      </span>
    </template> -->
    <p></p>
    <p>
      Workflow name:
      <strong>{{ workflowName }}</strong>
    </p>
    <p>
      Workflow startt title:
      <strong>{{ workflowStartTitle }}</strong>
    </p>
  </b-form-group>
</template>

<script>
// helpers
import constants from '@/helpers/constants'
import { mapState } from 'vuex'

export default {
  props: ['control'],
  data () {
    return {
      cmOptions: constants.cmTemplateOptions,
      workflow: '',
      designedWorkflows: []
    }
  },
  computed: {
    ...mapState({
      workflows: 'workflows',
      dataGrid_options: 'dataGrid_options'
    }),
    workflowName(){
      return this.dataGrid_options[this.control.gridId].meta[this.control.propName].displayName
    },
    workflowStartTitle(){
      return this.dataGrid_options[this.control.gridId].meta[this.control.propName].startTitle
    }
  },
  methods: {
    onCmCodeChange (value) {
      this.control.customCode = value
    },
  },
  mounted() {
    for(let i in this.workflows){
      this.designedWorkflows.push(this.workflows[i])
    }
  }
}
</script>
